import React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import './schedule-call-cta.scss'

const CALENDLY_URL = 'https://calendly.com/smartsoft'

const ScheduleCallCta = () => {
  const { t } = useTranslation()

  return (
    <div className="ss-schedule-call-cta">
      <a
        className="ss-schedule-call-cta__button"
        href={CALENDLY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('Schedule a call')}
      </a>
    </div>
  )
}

export default ScheduleCallCta
